<div class="content">
    <span class="mat-title">Aprovar recrutadores</span>
    
    <div class="row" style="margin-top: 10px;">
        <mat-form-field appearance="outline">
        <mat-label>Digite o CNPJ</mat-label>
        <input matInput [(ngModel)]="cnpj" placeholder="00.000.000/0000-00" maxlength="14" (keypress)="validateNumberInput($event)">
        <button mat-icon-button matSuffix (click)="searchCompany()">
            <mat-icon>search</mat-icon>
        </button>
        </mat-form-field>
    </div>

    <div class="row table-responsive">
        <table mat-table [dataSource]="companies" matSort class="mat-table" *ngIf="cnpjSearched">
            <tbody>
            
                <!-- Empresa Column -->
                <ng-container matColumnDef="businessname">
                <th mat-header-cell *matHeaderCellDef>Empresa</th>
                <td mat-cell *matCellDef="let company" data-label="Empresa">{{ company.businessname }}</td>
                </ng-container>
            
                <!-- CNPJ Column -->
                <ng-container matColumnDef="cnpj">
                <th mat-header-cell *matHeaderCellDef>CNPJ</th>
                <td mat-cell *matCellDef="let company" data-label="CNPJ">{{ company.cnpj | mask:'00.000.000/0000-00' }}</td>
                </ng-container>
            
                <!-- Email Column -->
                <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef>Email</th>
                <td mat-cell *matCellDef="let company" data-label="Email">{{ company.companyemail }}</td>
                </ng-container>
            
                <!-- Telefone Column -->
                <ng-container matColumnDef="phone">
                <th mat-header-cell *matHeaderCellDef>Telefone</th>
                <td mat-cell *matCellDef="let company" data-label="Telefone">{{ company.companyphone | mask:'(00) 00000-0000' }}</td>
                </ng-container>
            
                <!-- Approve Column -->
                <ng-container matColumnDef="approve">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let company" data-label="Status">{{ company.approve === '1' ? 'Aprovado' : 'Reprovado' }}</td>
                </ng-container>
            
                <!-- Ação Column -->
                <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Ação</th>
                <td mat-cell *matCellDef="let company" data-label="Ação">
                    <div *ngIf="company.approve">
                        <button mat-raised-button color="primary" (click)="verifyCompany(company.companyemail, 1)" *ngIf="company.approve === '0'">Aprovar</button>
                        <button mat-raised-button color="warn" (click)="verifyCompany(company.companyemail, 0)" *ngIf="company.approve === '1'">Reprovar</button>
                    </div>
                    <div *ngIf="!company.approve">
                        <button mat-raised-button color="primary" (click)="verifyCompany(company.companyemail, 1)">Aprovar</button>
                    </div>
                </td>
                </ng-container>
            
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </tbody>
        </table>
    </div>

    <div class="historic" style="margin-top: 10px;">
        <div class="empty-content" *ngIf="!cnpjSearched">
            <span class="mat-body-2 text-center">Nenhuma Empresa Encontrada<br>
            <small>Utilize o campo acima para pesquisar a empresa pelo CNPJ.</small></span>
        </div>
      </div>

  </div>
  